module.exports = __webpack_public_path__ + "static/img/Jada-Whyman.de45249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jada-Whyman.jpg
// module id = EbVZ
// module chunks = 0